import * as Types from '../../__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginVariables = Types.Exact<{
  username: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
  usertype: Types.UserType;
  captcha?: Types.InputMaybe<Types.Scalars['String']['input']>;
  codeChallenge?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type Login = { __typename?: 'Mutation', Login?: any | null };


export const LoginDocument = gql`
    mutation Login($username: String!, $password: String!, $usertype: UserType!, $captcha: String, $codeChallenge: String) {
  Login(
    username: $username
    password: $password
    usertype: $usertype
    captcha: $captcha
    code_challenge: $codeChallenge
  )
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<Login, LoginVariables>;

/**
 * __useLogin__
 *
 * To run a mutation, you first call `useLogin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [login, { data, loading, error }] = useLogin({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      usertype: // value for 'usertype'
 *      captcha: // value for 'captcha'
 *      codeChallenge: // value for 'codeChallenge'
 *   },
 * });
 */
export function useLogin(baseOptions?: Apollo.MutationHookOptions<Login, LoginVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Login, LoginVariables>(LoginDocument, options);
      }
export type LoginHookResult = ReturnType<typeof useLogin>;
export type LoginMutationResult = Apollo.MutationResult<Login>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<Login, LoginVariables>;